import { FC, useContext, useEffect, useState } from "react";
import LayoutComponentProps from "./LayoutHeaderComponentProps";
import UserContextType from "../../../../../domain/providers/user/UserContextType";
import UserContext from "../../../../providers/user/UserContext";
import di from "../../../../../dependency_injection";
import ChangeThemeUseCase, {
  ChangeThemeUseCaseName,
} from "../../../../../domain/use_cases/settings/change_theme.use_case";
import KeyWordLocalization from "../../../../utils/KeyWordLocalization";
import LoadThemeUseCase, {
  LoadThemeUseCaseName,
} from "../../../../../domain/use_cases/settings/load_theme.use_case";

const LayoutHeaderComponent: FC<LayoutComponentProps> = ({
  title,
  open,
  setOpen,
}) => {
  const { user } = useContext(UserContext) as UserContextType;
  const handleToggle = () => setOpen(!open);
  const [currentMode, setCurrentMode] = useState<string | undefined>(undefined);

  const _handleChangeTheme = () => {
    const order = [
      KeyWordLocalization.ChangeThemeUseCaseDark,
    //   KeyWordLocalization.ChangeThemeUseCaseSystem,
      KeyWordLocalization.ChangeThemeUseCaseLight,
    ];
    const getNext = (order.indexOf(currentMode ?? "") + 1) % order.length;
    setCurrentMode(order[getNext]);
    console.log("changed to", currentMode, getNext, order[getNext]);
    di.get<ChangeThemeUseCase>(ChangeThemeUseCaseName).call(order[getNext]);
  };

  const _loadCurrentMode = async () => {
    const currentTheme = await di
      .get<LoadThemeUseCase>(LoadThemeUseCaseName)
      .call();
    setCurrentMode(currentTheme);
  };

  useEffect(() => {
    _loadCurrentMode();
  }, []);
  return (
    <nav className="header">
      <div className="btn_open hover" onClick={handleToggle}>
        <span className="material-symbols-outlined">
          {open ? "menu_open" : "menu"}
        </span>
      </div>
      <div className="title">{title}</div>
      <div
        className="btn_theme hover mx-3 d-flex align-items-center justify-content-center"
        onClick={_handleChangeTheme}
      >
        {/* <span className="material-symbols-outlined">
          {currentMode === KeyWordLocalization.ChangeThemeUseCaseDark
            ? "dark_mode"
            : currentMode === KeyWordLocalization.ChangeThemeUseCaseLight
            ? "light_mode"
            : "brightness_auto"}
        </span> */}
        <span className="material-symbols-outlined">
          {currentMode === KeyWordLocalization.ChangeThemeUseCaseDark
            ? "dark_mode"
            : "light_mode"}
        </span>
      </div>
      {user && (
        <div className="user d-flex align-items-center">
          <div className="user_photo">
            <img src={user.photo} alt="" />
          </div>
          <div className="ms-3 info">
            <strong>{user.name}</strong>
            <br />
            {user.clientName}
          </div>
        </div>
      )}
    </nav>
  );
};

export default LayoutHeaderComponent;
